// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
	box-sizing: border-box;
}
* {
	margin: 0;
}
body {
	line-height: 1.5;
	-webkit-font-smoothing: antialiased;
}
picture,
video,
canvas,
svg {
	display: block;
	max-width: 100%;
}
input,
button,
textarea,
select {
	font: inherit;
}
p,
h1,
h2,
h3,
h4,
h5,
h6 {
	overflow-wrap: break-word;
}
p {
	text-wrap: pretty;
}
h1,
h2,
h3,
h4,
h5,
h6 {
	text-wrap: balance;
}
ul {
	list-style-type: none;
}

body {
	display: flex;
	flex-direction: column;
	height: 100vh;
	background-color: #181a1b;
	color: white;
	& > header {
		padding-top: 20px;
		display: flex;
		justify-content: space-around;
		align-items: center;
		margin-bottom: 100px;
		& > .title {
			font-size: 30px;
			font-weight: bold;
		}
		& > .game-status {
			background-color: rgb(40, 39, 39);
			width: 300px;
			font-size: 19px;
			display: flex;
			align-items: center;
			justify-content: center;
		}
		& .rules > a {
			color: lightgray;
		}
	}
	& > .play-button-container {
		display: flex;
		justify-content: center;
		margin-top: 30px;
		& > .play-button {
			border: none;
			background-color: darkgreen;
			color: white;
			font-size: 19px;
			padding: 10px 20px;
			border-radius: 15px;
			text-align: center;
			width: fit-content;
		}
		& > .play-button:hover {
			background-color: rgb(3, 113, 3);
			cursor: pointer;
		}
		& > .play-button:active {
			transform: translateY(1px);
			background-color: rgb(9, 130, 9);
		}
		& > .play-button.reset {
			background-color: darkred;
		}
	}
}

.gameboards-container {
	display: flex;
	justify-content: center;
	gap: 150px;
	& .gameboard-container {
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 15px;
	}
	& .gameboard {
		display: grid;
		grid-template-columns: repeat(10, 35px);
		grid-template-rows: repeat(10, 35px);
		gap: 1px;
	}
	& .gameboard > div {
		outline: 1px solid rgb(17, 153, 17);
	}
	& .gameboard > div.ship {
		background-color: lime;
	}
	& .gameboard > div.missed {
		background-color: gray;
	}
	& .gameboard > div.hit {
		background-color: red;
	}
	& .gameboard:not(.opacity) > div.computer-square:not(.hit, .missed):hover {
		background-color: #25282a;
		cursor: pointer;
	}
	& .gameboard:not(.opacity) > div.computer-square:not(.hit, .missed):active {
		background-color: #3c4246;
	}
	& .randomize-button {
		display: flex;
		border: none;
		background-color: inherit;
		padding: 10px;
		cursor: pointer;
		border-radius: 15px;
	}
	& .randomize-button:hover {
		background-color: rgb(40, 39, 39);
	}
}

.opacity {
	opacity: 0.4;
}
`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA;;;CAGC,sBAAsB;AACvB;AACA;CACC,SAAS;AACV;AACA;CACC,gBAAgB;CAChB,mCAAmC;AACpC;AACA;;;;CAIC,cAAc;CACd,eAAe;AAChB;AACA;;;;CAIC,aAAa;AACd;AACA;;;;;;;CAOC,yBAAyB;AAC1B;AACA;CACC,iBAAiB;AAClB;AACA;;;;;;CAMC,kBAAkB;AACnB;AACA;CACC,qBAAqB;AACtB;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,aAAa;CACb,yBAAyB;CACzB,YAAY;CACZ;EACC,iBAAiB;EACjB,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,oBAAoB;EACpB;GACC,eAAe;GACf,iBAAiB;EAClB;EACA;GACC,iCAAiC;GACjC,YAAY;GACZ,eAAe;GACf,aAAa;GACb,mBAAmB;GACnB,uBAAuB;EACxB;EACA;GACC,gBAAgB;EACjB;CACD;CACA;EACC,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB;GACC,YAAY;GACZ,2BAA2B;GAC3B,YAAY;GACZ,eAAe;GACf,kBAAkB;GAClB,mBAAmB;GACnB,kBAAkB;GAClB,kBAAkB;EACnB;EACA;GACC,gCAAgC;GAChC,eAAe;EAChB;EACA;GACC,0BAA0B;GAC1B,gCAAgC;EACjC;EACA;GACC,yBAAyB;EAC1B;CACD;AACD;;AAEA;CACC,aAAa;CACb,uBAAuB;CACvB,UAAU;CACV;EACC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;CACV;CACA;EACC,aAAa;EACb,uCAAuC;EACvC,oCAAoC;EACpC,QAAQ;CACT;CACA;EACC,mCAAmC;CACpC;CACA;EACC,sBAAsB;CACvB;CACA;EACC,sBAAsB;CACvB;CACA;EACC,qBAAqB;CACtB;CACA;EACC,yBAAyB;EACzB,eAAe;CAChB;CACA;EACC,yBAAyB;CAC1B;CACA;EACC,aAAa;EACb,YAAY;EACZ,yBAAyB;EACzB,aAAa;EACb,eAAe;EACf,mBAAmB;CACpB;CACA;EACC,iCAAiC;CAClC;AACD;;AAEA;CACC,YAAY;AACb","sourcesContent":["*,\n*::before,\n*::after {\n\tbox-sizing: border-box;\n}\n* {\n\tmargin: 0;\n}\nbody {\n\tline-height: 1.5;\n\t-webkit-font-smoothing: antialiased;\n}\npicture,\nvideo,\ncanvas,\nsvg {\n\tdisplay: block;\n\tmax-width: 100%;\n}\ninput,\nbutton,\ntextarea,\nselect {\n\tfont: inherit;\n}\np,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n\toverflow-wrap: break-word;\n}\np {\n\ttext-wrap: pretty;\n}\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n\ttext-wrap: balance;\n}\nul {\n\tlist-style-type: none;\n}\n\nbody {\n\tdisplay: flex;\n\tflex-direction: column;\n\theight: 100vh;\n\tbackground-color: #181a1b;\n\tcolor: white;\n\t& > header {\n\t\tpadding-top: 20px;\n\t\tdisplay: flex;\n\t\tjustify-content: space-around;\n\t\talign-items: center;\n\t\tmargin-bottom: 100px;\n\t\t& > .title {\n\t\t\tfont-size: 30px;\n\t\t\tfont-weight: bold;\n\t\t}\n\t\t& > .game-status {\n\t\t\tbackground-color: rgb(40, 39, 39);\n\t\t\twidth: 300px;\n\t\t\tfont-size: 19px;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;\n\t\t}\n\t\t& .rules > a {\n\t\t\tcolor: lightgray;\n\t\t}\n\t}\n\t& > .play-button-container {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\tmargin-top: 30px;\n\t\t& > .play-button {\n\t\t\tborder: none;\n\t\t\tbackground-color: darkgreen;\n\t\t\tcolor: white;\n\t\t\tfont-size: 19px;\n\t\t\tpadding: 10px 20px;\n\t\t\tborder-radius: 15px;\n\t\t\ttext-align: center;\n\t\t\twidth: fit-content;\n\t\t}\n\t\t& > .play-button:hover {\n\t\t\tbackground-color: rgb(3, 113, 3);\n\t\t\tcursor: pointer;\n\t\t}\n\t\t& > .play-button:active {\n\t\t\ttransform: translateY(1px);\n\t\t\tbackground-color: rgb(9, 130, 9);\n\t\t}\n\t\t& > .play-button.reset {\n\t\t\tbackground-color: darkred;\n\t\t}\n\t}\n}\n\n.gameboards-container {\n\tdisplay: flex;\n\tjustify-content: center;\n\tgap: 150px;\n\t& .gameboard-container {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\talign-items: center;\n\t\tgap: 15px;\n\t}\n\t& .gameboard {\n\t\tdisplay: grid;\n\t\tgrid-template-columns: repeat(10, 35px);\n\t\tgrid-template-rows: repeat(10, 35px);\n\t\tgap: 1px;\n\t}\n\t& .gameboard > div {\n\t\toutline: 1px solid rgb(17, 153, 17);\n\t}\n\t& .gameboard > div.ship {\n\t\tbackground-color: lime;\n\t}\n\t& .gameboard > div.missed {\n\t\tbackground-color: gray;\n\t}\n\t& .gameboard > div.hit {\n\t\tbackground-color: red;\n\t}\n\t& .gameboard:not(.opacity) > div.computer-square:not(.hit, .missed):hover {\n\t\tbackground-color: #25282a;\n\t\tcursor: pointer;\n\t}\n\t& .gameboard:not(.opacity) > div.computer-square:not(.hit, .missed):active {\n\t\tbackground-color: #3c4246;\n\t}\n\t& .randomize-button {\n\t\tdisplay: flex;\n\t\tborder: none;\n\t\tbackground-color: inherit;\n\t\tpadding: 10px;\n\t\tcursor: pointer;\n\t\tborder-radius: 15px;\n\t}\n\t& .randomize-button:hover {\n\t\tbackground-color: rgb(40, 39, 39);\n\t}\n}\n\n.opacity {\n\topacity: 0.4;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
